import LastSearch from "./LastSearch";
import PropTypes from "prop-types";
import { WEBSITE_TUNNEL_TYPES } from "app/constants";
import useSearchHistory from "app/features/SearchEngine/LastSearch/hooks/useSearchHistory";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useMemo } from "react";
import { bindActionCreators } from "redux";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";
import { getAvailableStopoverCities } from "app/pages/SmartDP/smartDPSelectors";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const LastSearchContainer = ownProps => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	const props = { ...ownProps, ...stateProps, ...dispatchProps };
	const { websiteType, updateBooking } = props;
	const { history, clearHistory, removeSearch, getSearchSearchById } =
		useSearchHistory(websiteType);
	const { track } = useAnalytics();

	const handleItemClick = id => {
		const searchObject = getSearchSearchById(id);
		const data = searchObject?.data;

		if (data?.searchedAccommodation) {
			updateBooking({
				...data,
				destinationResort: {
					code: data.searchedAccommodation.id,
					label: data.searchedAccommodation.name,
					isHotel: true,
					places: data.searchedAccommodation.places,
				},
			});
		} else {
			updateBooking(data);
		}
	};

	const handleClearHistory = () => {
		clearHistory();
		track("last-searches-clear-history-click", {
			websiteType,
		});
	};

	const handleRemoveSearch = id => {
		removeSearch(id);
		track("last-searches-remove-search-click", {
			websiteType,
		});
	};

	return (
		<LastSearch
			{...props}
			websiteType={websiteType}
			lastSearches={history}
			onClearHistory={handleClearHistory}
			onRemoveSearch={handleRemoveSearch}
			onItemClick={handleItemClick}
		/>
	);
};

LastSearchContainer.propTypes = {
	websiteType: PropTypes.oneOf([
		WEBSITE_TUNNEL_TYPES.HOTEL_ONLY,
		WEBSITE_TUNNEL_TYPES.HOLIDAYS,
		WEBSITE_TUNNEL_TYPES.STOPOVER,
	]),
	updateBooking: PropTypes.func,
};

const mapStateToProps = state => {
	return {
		stopoverCities: getAvailableStopoverCities(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			updateBooking,
		},
		dispatch
	);
};

export default LastSearchContainer;
